import { motion, useReducedMotion } from "framer-motion";
import { useExplorer } from "@/context/ExplorerContext";
import { ImageSlot } from "@/components/lurio/ImageSlot";

// Position of the printed "Ce diplôme appartient à : ____" line (percent of the page).
const NAME_LINE = { left: "47%", top: "27.6%", width: "40.5%", height: "4.4%" };

// Real Diplôme page from the book, with a live (preview-only) name on the printed line.
export const DiplomaCard = ({ stamp = false, className = "", testId = "diploma-card" }) => {
  const { t, display } = useExplorer();
  const reduce = useReducedMotion();
  const name = display || t.namePrompt.fallback;
  return (
    <div data-testid={testId} className={`relative mx-auto w-full max-w-md rounded-book bg-cream-card p-2 shadow-[0_30px_60px_-30px_rgba(30,42,56,0.5)] [container-type:inline-size] ${className}`}>
      <ImageSlot id="page_diploma" rounded="rounded-[12px]" className="ring-1 ring-ink/10">
        <div className="absolute flex items-end justify-center" style={NAME_LINE}>
          {stamp ? (
            <motion.span
              data-testid="diploma-stamped-name"
              key={name}
              className="font-hand leading-none text-coral"
              style={{ fontSize: "clamp(1rem, 5.2cqw, 2.4rem)" }}
              initial={reduce ? false : { scale: 1.5, opacity: 0, rotate: -6 }}
              whileInView={{ scale: 1, opacity: 1, rotate: -2 }}
              viewport={{ once: true, margin: "-20% 0px" }}
              transition={{ duration: 0.5, ease: [0.34, 1.3, 0.64, 1] }}
            >
              {name}
            </motion.span>
          ) : (
            <span data-testid="diploma-name" className="font-hand leading-none text-blue" style={{ fontSize: "clamp(1rem, 5.2cqw, 2.4rem)" }}>
              {name}
            </span>
          )}
        </div>
      </ImageSlot>
    </div>
  );
};
